import React from 'react';
import './HeroBackground.css';

export function HeroBackground() {
  return (
    <div className="hero-bg-canvas">
      <div className="hero-bg-canvas__glow-circle" />
      <svg
        className="hero-bg-canvas__svg"
        viewBox="0 0 1400 700"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Subtle Archery Trajectory & Target Arcs */}
        <path
          d="M 320 200 C 480 80, 920 80, 1080 200"
          stroke="#93c5fd"
          strokeWidth="2"
          strokeDasharray="6 6"
        />
        <path
          d="M 280 420 C 450 580, 950 580, 1120 420"
          stroke="#93c5fd"
          strokeWidth="2"
          strokeDasharray="6 6"
        />
        <circle cx="700" cy="350" r="260" stroke="#bfdbfe" strokeWidth="1.5" strokeDasharray="4 8" />
        <circle cx="700" cy="350" r="340" stroke="#dbeafe" strokeWidth="1" />
        
        {/* Subtle decorative arrows / nodes */}
        <circle cx="320" cy="200" r="4" fill="#3b82f6" />
        <circle cx="1080" cy="200" r="4" fill="#3b82f6" />
        <polygon points="1085,195 1100,200 1085,205" fill="#3b82f6" />
        <polygon points="315,415 300,420 315,425" fill="#3b82f6" />
      </svg>
    </div>
  );
}
